import { useState } from 'react';

import { Step0 } from '../components/organisms/Step0';
import { Step1 } from '../components/organisms/Step1';
import { LandingLayout } from '../layouts';

/** Первый шаг анкеты: выбор «есть ли назначение врача» (как в форме заказа в ЛК). */
const PrescriptionChoiceStep = ({
  onNext,
}: {
  onNext: (hasPrescription: 'yes' | 'no' | 'unknown') => void;
}) => {
  const [value, setValue] = useState<'yes' | 'no' | 'unknown' | null>(null);
  return (
    <div className="flex w-full max-w-[720px] flex-col items-center gap-8 rounded-[24px] bg-white p-8">
      <p className="w-full text-center text-2xl leading-8 text-[#151515]">
        Есть ли у Вас назначение врача?
      </p>
      <div className="flex w-full items-center overflow-hidden rounded-[100px] bg-[#f7f8f9]">
        <button
          type="button"
          className={`flex flex-1 items-center justify-center gap-2 rounded-[100px] p-4 ${
            value === 'yes'
              ? 'bg-[#151515] text-[#f6f8f9]'
              : 'bg-[#f6f8f9] text-[#151515]/50'
          }`}
          onClick={() => setValue('yes')}
        >
          Да
        </button>
        <button
          type="button"
          className={`flex flex-1 items-center justify-center gap-2 rounded-[100px] p-4 ${
            value === 'no'
              ? 'bg-[#151515] text-[#f6f8f9]'
              : 'bg-[#f6f8f9] text-[#151515]/50'
          }`}
          onClick={() => setValue('no')}
        >
          Нет
        </button>
        <button
          type="button"
          className={`flex flex-1 items-center justify-center gap-2 rounded-[100px] p-4 ${
            value === 'unknown'
              ? 'bg-[#151515] text-[#f6f8f9]'
              : 'bg-[#f6f8f9] text-[#151515]/50'
          }`}
          onClick={() => setValue('unknown')}
        >
          Не знаю
        </button>
      </div>
      <button
        type="button"
        disabled={value === null}
        className="flex h-14 w-full items-center justify-center rounded-[12px] bg-[#0788f1] px-5 text-base font-bold leading-5 text-white disabled:opacity-50"
        onClick={() => value !== null && onNext(value)}
      >
        Продолжить
      </button>
    </div>
  );
};

export const LandingFormPage = () => {
  const [currentStep, setCurrentStep] = useState<0 | 1 | 2>(0);
  const [formData, setFormData] = useState<Record<string, unknown>>({});
  const [userId, setUserId] = useState<number | null>(null);
  const [hasPrescription, setHasPrescription] = useState<
    'yes' | 'no' | 'unknown' | null
  >(null);

  const goToRegistration = (prescription: 'yes' | 'no' | 'unknown') => {
    setHasPrescription(prescription);
    setCurrentStep(1);
  };

  const nextToOrder = (data: { userId?: number }) => {
    setFormData((prev) => ({ ...prev, ...data }));
    if (data.userId) setUserId(data.userId);
    setCurrentStep(2);
  };

  const prevStep = () => {
    if (currentStep === 2) setCurrentStep(1);
    else if (currentStep === 1) setCurrentStep(0);
  };

  return (
    <LandingLayout>
      <div className="outerWrapper">
        <div className="blueCard">
          {currentStep === 0 && (
            <PrescriptionChoiceStep onNext={goToRegistration} />
          )}
          {currentStep === 1 && <Step0 onNext={nextToOrder} />}
          {currentStep === 2 && userId !== null && (
            <Step1 onPrev={prevStep} formData={formData} userId={userId} />
          )}
        </div>
      </div>
    </LandingLayout>
  );
};
